import { createContext, useContext } from 'react';

interface SpaceProfile {
  space: {
    name: string;
    slug: string;
    expressBookEnabled: boolean;
    images: {
      url: string;
    }[];
  };
  venue: {
    name: string;
    slug: string;
    address?: {
      streetAddress1?: string;
      streetAddress2?: string;
      city?: string;
      state?: string;
    };
    liveAvailability: boolean;
    menu: {
      previewMenuItems: {
        id: string;
        name: string;
        image: string;
      }[];
    };
    images: {
      url: string;
    }[];
  };
}

export const SpaceProfileContext = createContext<SpaceProfile | undefined>(
  undefined,
);

export const useSpaceProfile = () => {
  const context = useContext(SpaceProfileContext);

  if (!context) {
    throw new Error(
      'useSpaceProfile must be used within a SpaceProfileProvider',
    );
  }
  return context;
};
